import axios from 'axios';

// Use relative URL for production (served by backend), localhost for dev
const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Helper function to check if JWT token is expired
function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    // Check if token expires within the next 5 minutes
    return payload.exp * 1000 < Date.now() + 5 * 60 * 1000;
  } catch {
    return true; // If we can't parse the token, consider it expired
  }
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('crs_token');
  if (token) {
    // Check if token is expired before sending request
    if (isTokenExpired(token)) {
      // Token is expired, clear storage and redirect to login
      localStorage.removeItem('crs_token');
      localStorage.removeItem('crs_user');
      localStorage.removeItem('crs_company');
      window.location.href = '/login';
      return Promise.reject(new Error('Token expired'));
    }
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      // Token expired or invalid - clear storage and redirect to login
      localStorage.removeItem('crs_token');
      localStorage.removeItem('crs_user');
      localStorage.removeItem('crs_company');
      // Use window.location to force a full page reload to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
